import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../../../hooks/redux';
import { useCustomSnackbar } from '../../../../hooks/useCustomEnqueueSnackbar';
import { authorizationApi } from '../../../../services/apiServices/user/authorization';
import { authSlice } from '../../../../store/reducers/AuthSlice';
import { userInfoSlice } from '../../../../store/reducers/UserInfoSlice';
import { ButtonClassNames, GlobalRouteNames, LocalStorageItems, LoginRouteNames } from '../../../../models/Common';
import { ApiError } from '../../../../models/ApiError';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { AnimatedIcon } from '../../AnimatedIcon';
import PasswordIconLight from '../../../../assets/images/lottieIcons/password/password.light.json';
import PasswordIconDark from '../../../../assets/images/lottieIcons/password/password.dark.json';
import { getErrorMessage } from '../../../../utils';

interface ILogOut {
  handleClose: () => void;
}

export const LogOut: FC<ILogOut> = ({ handleClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const { logout } = authSlice.actions;
  const [logoutApi] = authorizationApi.useLogoutMutation();
  const { resetUserInfoAfterLogout } = userInfoSlice.actions;
  const dispatch = useAppDispatch();

  const onLogout = async () => {
    try {
      await logoutApi('').unwrap();
      localStorage.removeItem(LocalStorageItems.ControlledAccount);
      dispatch(resetUserInfoAfterLogout());
      dispatch(logout());
      history.push(`${GlobalRouteNames.LoginPage}${LoginRouteNames.ForgotPasswordForm}`);
    } catch (err) {
      const error = err as ApiError;
      if (error.status !== 403) {
        const message = getErrorMessage(err);
        customEnqueueSnackbar(message, 'error');
      }
    }
  };

  const logoutHandler = () => {
    onLogout();
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header modals__header__top-up">
        <AnimatedIcon lightIcon={PasswordIconLight} darkIcon={PasswordIconDark} className="icon-password" />
        <article className="modals__header__title">{t('auth.doNotRememberPassword')}</article>
        <p className="modals__header__description">{t('auth.restoreYourPassword')}</p>
        <p className="modals__header__description" style={{ color: 'var(--color-error)' }}>
          {t('auth.youWillBeLoggedOut')}
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.continue')}
          handleClick={logoutHandler}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
        <CustomMUIButton
          label={t('buttons.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
      </div>
    </div>
  );
};
